import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login'
import Home from '@/components/Home'
import Role from '@/components/Role'
import Activity from '@/components/Activity'
import Business from '@/components/Business'
import Areas from '@/components/Areas'
import Country from '@/components/Country'
import Company from '@/components/Company'
import Site from '@/components/Site'
import Assessor from '@/components/Assessor'
import User from '@/components/User'
import Standard from '@/components/Standard'
import Assessment from '@/components/Assessment'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/dashboard',
      name: 'Home',
      component: Home
    },
    {
      path: '/',
      name: 'Login',
      component: Login
    },
    {
      path: '/roles',
      name: 'Role',
      component: Role
    },
    {
      path: '/activities',
      name: 'Activity',
      component: Activity
    },
    {
      path: '/business',
      name: 'Business',
      component: Business
    },
    {
      path: '/areas',
      name: 'Areas',
      component: Areas
    },
    {
      path: '/countries',
      name: 'Country',
      component: Country
    },
    {
      path: '/companies',
      name: 'Company',
      component: Company
    },
    {
      path: '/sites',
      name: 'Site',
      component: Site
    },
    {
      path: '/assessors',
      name: 'Assessor',
      component: Assessor
    },
    {
      path: '/users',
      name: 'User',
      component: User
    },
    {
      path: '/standards',
      name: 'Standard',
      component: Standard
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js